var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4966_6799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.2V29H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4966_6799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4516 0.293638C13.7641 -0.0978793 12.9171 -0.0978793 12.2296 0.293638L1.11068 6.62978C0.423175 7.0213 -0.000318527 7.74525 -0.000318527 8.52872V21.2001C-0.000318527 21.9836 0.423175 22.7076 1.11068 23.0995L11.1186 28.8021C12.1063 29.3647 13.3406 28.661 13.3406 27.5358V16.1307C13.3406 15.3472 13.7641 14.6228 14.4516 14.2313L24.4591 8.52872C25.4468 7.96614 25.4468 6.55923 24.4591 5.99665L14.4516 0.293638Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1848 18.6594C18.1848 17.959 18.5606 17.3126 19.1702 16.9623L25.3439 13.42C26.2198 12.9169 27.3154 13.5457 27.3154 14.5514V21.6361C27.3154 22.3365 26.9396 22.983 26.3296 23.3332L20.1563 26.8755C19.28 27.3782 18.1848 26.7499 18.1848 25.7441V18.6594Z",
    fill: "#26FF7B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1abfd6a6.svg";
export { ForwardRef as ReactComponent };